export const BASE_IMAGE_URL =
  'https://www.nerdwallet.com/cdn-cgi/image/format=webp,quality=80/cdn/apps/prod/front-page/images/homepage/superbowl';

export const BASE_CDN_URL =
  'https://www.nerdwallet.com/cdn/apps/prod/front-page/images/homepage/superbowl';

export const BEST_OF_AWARDS_2025_URL =
  'https://www.nerdwallet.com/l/awards?trk=boa_2025_banner';
